module.exports = __webpack_public_path__ + "img/course5.fa8a7869.png";